/** TeamOnboardingGate's decision (#803), in its own module so the component file
 *  exports only a component (react-refresh) and the rule is tested without a DOM. */
function allowNoTeam(pathname: string) {
  return (
    pathname.startsWith("/join/") ||
    pathname === "/onboarding/team/new"
  );
}

/** What the gate shows. The spinner is for
 *  the FIRST team load only; a background refetch keeps the page mounted. */
export function gateView(v: {
  signedIn: boolean; pathname: string; initialized: boolean; teamCount: number;
}): "page" | "spinner" | "onboarding" {
  if (!v.signedIn || allowNoTeam(v.pathname)) return "page";
  if (!v.initialized) return "spinner";
  return v.teamCount === 0 ? "onboarding" : "page";
}
